import React from "react";
import './css/OurTeamStyle.css';
import teacher1 from './faculty/praveen_co_founder.png';
import teacher2 from './faculty/amit_co_founder.png';
import teacher3 from './faculty/ritika_teacher.png';
import teacher4 from './faculty/akshit_teacher.png';
import teacher5 from './faculty/himanshu_teacher.png';
import teacher6 from './faculty/devendr_teacher.png';
import teacher7 from './faculty/Shiwangi.png';
import teacher8 from './faculty/Supriya.png';


function OurTeam(){
    return (
        <section class="py-5 text-center bg-light">
            <div class="container">
                <h2 class="fw-bold mb-2">Our <span class="text-gradient">Strong Team</span></h2>
                <p class="text-muted mb-5 w-60 mx-auto">A dedicated team of passionate educators committed to fostering a supportive and inspiring learning environment for every student</p>
                <div class="row g-4 justify-content-center">
                    <div class="col-md-3 hover-card">
                        <div class="card border-0 shadow-sm">
                            <img src={teacher1} class="card-img-top" alt="Glen Butler" />
                            <div class="card-body">
                                <h5 class="card-title mb-0 fw-bold">Praveen Malik</h5>
                                <small class="text-muted">Founder of Vigyan Vriksh</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card border-0 shadow-sm hover-card">
                            <img src={teacher2} class="card-img-top" alt="Jane Cooper" />
                            <div class="card-body">
                                <h5 class="card-title mb-0 fw-bold">Amit Kumar Lamba</h5>
                                <small class="text-muted">Founder of Vigyan Vriksh</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card border-0 shadow-sm">
                            <img src={teacher5} class="card-img-top" alt="Marley Allison" />
                            <div class="card-body">
                                <h5 class="card-title mb-0 fw-bold">Himanshu Papnai</h5>
                                <small class="text-muted">Educator</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card border-0 shadow-sm">
                            <img src={teacher6} class="card-img-top" alt="Marley Allison" />
                            <div class="card-body">
                                <h5 class="card-title mb-0 fw-bold">Devendra Tripathi</h5>
                                <small class="text-muted">Educator</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card border-0 shadow-sm">
                            <img src={teacher3} class="card-img-top" alt="Lesley Cooper" />
                            <div class="card-body">
                                <h5 class="card-title mb-0 fw-bold">Ritika Gupta</h5>
                                <small class="text-muted">Educators</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card border-0 shadow-sm">
                            <img src={teacher4} class="card-img-top" alt="Marley Allison" />
                            <div class="card-body">
                                <h5 class="card-title mb-0 fw-bold">Akshat Jain</h5>
                                <small class="text-muted">Educator</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card border-0 shadow-sm">
                            <img src={teacher7} class="card-img-top" alt="Marley Allison" />
                            <div class="card-body">
                                <h5 class="card-title mb-0 fw-bold">Shiwangi</h5>
                                <small class="text-muted">Educator</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="card border-0 shadow-sm">
                            <img src={teacher8} class="card-img-top" alt="Marley Allison" />
                            <div class="card-body">
                                <h5 class="card-title mb-0 fw-bold">Supriya</h5>
                                <small class="text-muted">Educator</small>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
    );
}
export default OurTeam;